var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomStack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 16,
      height: 18
    },
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9784 9.62527V14.7932H7.95584V9.62527L5.21334 11.9027L4.49039 11.3023L8.46712 8L12.4438 11.3023L11.7209 11.9027L8.9784 9.62527Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9784 1.62527V6.7932H7.95584V1.62527L5.21334 3.90269L4.49039 3.30234L8.46712 0L12.4438 3.30234L11.7209 3.90269L8.9784 1.62527Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.000488281,
    y: 17.6631,
    width: 1.77778,
    height: 16,
    transform: "rotate(-90 -0.000488281 17.6631)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomStack);
export default __webpack_public_path__ + "static/media/bottom_stack.2a41cde5462c71e15ee1b6d0dfa7fb68.svg";
export { ForwardRef as ReactComponent };